const createUserDialog = {
  title: "Create New User",
  labels: {
    email: "Email *",
    fullName: "Full Name *",
    institution: "Institution *",
    password: "Password *",
    confirmPassword: "Confirm Password *",
    role: "Role",
  },
  roles: {
    researcher: "Researcher",
    pi: "Principal Investigator (PI)",
    manager: "Manager",
    dataUploader: "Data Uploader",
  },
  errors: {
    allFieldsRequired: "All fields are required",
    passwordMismatch: "Passwords do not match",
    passwordTooShort: "Password must be at least 8 characters long",
    createFailed: "Failed to create user",
  },
  creating: "Creating...",
  createButton: "Create User",
};

export default createUserDialog;
